'use client';

import useRequestCountryCode from '@alltrails/context/hooks/useRequestCountryCode';
import Page from '@alltrails/layout/components/Page';
import AppDownloadAndReview from '@/components/welcome/AppDownloadAndReview/AppDownloadAndReview';
import GivingBack from '@/components/welcome/GivingBack/GivingBack';
import Header from '@/components/welcome/Header/Header';
import PlusFeatureList from '@/components/welcome/PlusFeatureList/PlusFeatureList';
import ProComparison from '@/components/welcome/ProComparison/ProComparison';
import styles from './WelcomePage.module.scss';

// Figma: https://www.figma.com/design/vEOyjIPghH0mvy5cP3CMeQ/Paid-Landing-Page-Refresh--Web-?node-id=283-9175&p=f&t=tKZAhZZUlUQj0mzT-0

export default function WelcomePage() {
  const requestCountryCode = useRequestCountryCode();
  const isUSVariant = requestCountryCode === 'US';

  return (
    <Page>
      <div className={styles.container}>
        <Header />
        <ProComparison />
        <PlusFeatureList isUSVariant={isUSVariant} />
        <AppDownloadAndReview />
      </div>
      <GivingBack />
    </Page>
  );
}
